import API_ENDPOINT from "../constants/api_endpoint.constant";
import axios from '../utils/axiosService';


export default class AdAddressService {
    getData(zip = "") {
        return axios.get(`${API_ENDPOINT.AD_ADDRESS}?zip=${zip}`);
    }
}
